(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){

module.exports = {
	hideAnnouncement: function() {
		
		$('.close-announcement').on('click', function(){
			$('#announcement').slideUp(300);
			$('body').removeClass('show-announcement');
		});
		
	}
	
}
},{}],2:[function(require,module,exports){


module.exports = {
	initFAQ: function () {

		$('.faq-item').on('click', function(){
			$(this).toggleClass('active');
			$(this).children('.faq-answer').slideToggle(300);
		});
	}
}
},{}],3:[function(require,module,exports){

module.exports = {
	initHotspots: function () {
		
		
		$('.hotspot').on('mouseenter', function(){
			var hotspotID = $(this).data('hotspot-id');
			gsap.to('.hotspot-text', { autoAlpha:0, y: '-90%',duration: .3, ease: "back.out(3)" });
			gsap.to('#'+hotspotID, { autoAlpha:1, y: '-115%', duration: .3 , ease: "back.out(3)"});
			
		}).on('mouseleave', function(){
				gsap.to('.hotspot-text', { autoAlpha:0, y: '-90%',duration: .3 , ease: "back.in(1)"});
			
		});
	},
	
};

},{}],4:[function(require,module,exports){

module.exports = {
	initFormLabel: function () {
		$('.form-waitlist .input-text, .form-waitlist .input-textarea, .form-waitlist .input-email, .form-waitlist .input-tel').on('focus blur', function(e) {
			var $inputWrapper = $(this).parent('.input-wrapper');
			if (e.type === 'focus' || $(this).val()) {
				$inputWrapper.addClass('active');
			} else {
				$inputWrapper.removeClass('active');
			}
		});
	},
		submitForm: function (container) {
		var theForm = $('.form-waitlist', container);
		var pageName = $('.form-waitlist #page_name', container).val();
		var pageUrl = $('.form-waitlist #page_url', container).val();
		
		 
		theForm.submit(function(e) {
			e.preventDefault();
			theformID = $(this).attr('id');
		}).validate({
			errorPlacement: function(error, element) {
				error.insertAfter(element);
			},
			submitHandler: function (form) {
				submitHubSpotForm(theformID,pageName,pageUrl);
			}
		});
		
		
		function submitHubSpotForm(theformID,pageName,pageUrl){
			
			var loadingDots = gsap.timeline({
				paused: true,
				repeat:  -1,
				repeatDelay: 0.3,
				yoyo: false
			})
			.to('.form-waitlist .dots', {
				duration: 0,
				text: ""
			})
			.to('.form-waitlist .dots', {
				duration: 0.9,
				text: "..."
			});
			loadingDots.play();
			var submit_url = ipAjaxVar.siteurl + '/partials/blocks/mailing-list/submit_hubspot.php';
			var formData = $('#'+theformID).serialize();
			formData += '&page_name=' + encodeURIComponent(pageName) + '&page_url=' + encodeURIComponent(pageUrl);
			
			$.ajax({
				url: submit_url,
				type: 'POST',
				data: formData,
				success: function (response) {
					console.log('success');
					$('#'+theformID+' .form-loading').fadeOut();
					$('#'+theformID+' .form-message.form-success').fadeIn();
					$('#'+theformID).trigger('reset');
					$('.form-waitlist .input-wrapper').removeClass('active');
					setTimeout(function() {
						$('.form-message').fadeOut().html('');
					}, 4000);
				},
					error: function (response) {
					console.log('error');
					$('#'+theformID+' .form-loading').fadeOut();
					$('#'+theformID+' .form-message.form-error').addClass('error').html('There was an error. Please try again').fadeIn();
					setTimeout(function() {
						$('#'+theformID+' .form-message').fadeOut().html('');
					}, 4000);
				}
			});
		};
	}, 
};

},{}],5:[function(require,module,exports){

module.exports = {
	filterNews: function() {
		var $newsNavigation = $('#news-categories');
		var currentCategory = '';
		
		$('a',$newsNavigation).on('click', function(e){
			e.preventDefault();
			currentCategory = $(this).data('category');
			
			$('a', $newsNavigation).removeClass('active');
			$(this).addClass('active');
			
			$('.news-item').fadeOut();
			
			setTimeout(function(){
				if(currentCategory == 'all'){
					$('.news-item').fadeIn();
				} else {
					
						$('.news-item[data-category="'+currentCategory+'"').fadeIn();	
					
				}
			}, 300);
			
		});
		
	}, 
	
};

},{}],6:[function(require,module,exports){

module.exports = {
	initTeamCarousel: function () {
		const swiper = new Swiper('.team-wrapper', {
			direction: 'horizontal',
			loop: false,
			slidesPerView: 3,
			spaceBetween: 10,
			grabCursor: true,
			speed: 600,
			breakpoints: {
				640: {
					slidesPerView: 3,
					spaceBetween: 32,
					navigation: {
						enabled: true,
					    nextEl: '.swiper-button-next',
					    prevEl: '.swiper-button-prev',
					},
				},
				 320: {
			      slidesPerView: 1,
			      spaceBetween: 16,
				  navigation: {
						enabled: false,
					    nextEl: '.swiper-button-next',
					    prevEl: '.swiper-button-prev',
					},
			    },
				
			},
			pagination: {
				el: '.swiper-pagination',
				clickable: true
			},
			
		});
	}
	
};
},{}],7:[function(require,module,exports){

module.exports = {
	hideMobileNav: function() {
		
		myVars.currentTop = $(window).scrollTop();
		
		if (myVars.isNavActive == true) {
			myVars.isNavActive = false;
			$('body').removeClass('navigation-open');
			$('#mobile-navigation').removeClass('active');
			$('.mobile-menu-icon').removeClass('is-active');
			$('#mobile-navigation').addClass('active').css('padding-top', myVars.navbarHeight + 'px');
			
//			if($('body').hasClass('show-announcement')){
//				$('#announcement').slideDown(300);
//			}
			
			if( myVars.currentTop > 0){
				$('#main-header').removeClass('scrolling-nav').addClass('hide-nav');
			}
			
			gsap.to('#mobile-navigation', {
				duration: 1,
				y: -150,
				autoAlpha: 0,
				ease: Power4.easeOut
			});
			
		}
	
	}, 
	
	showMobileNav: function() {
			if (myVars.isNavActive == false) {
				myVars.isNavActive = true;
				$('body').addClass('navigation-open');
				$('.mobile-menu-icon').addClass('is-active');
				$('#mobile-navigation').addClass('active').css('padding-top', myVars.navbarHeight + 'px');
				
				if($('body').hasClass('show-announcement')){
					$('#announcement').slideUp(300);
				}
				
				gsap.set('#mobile-navigation', {y: 150, opacity:0});
				
				var tlMobileNavigation = gsap.timeline();
	
				tlMobileNavigation.to('#mobile-navigation', {
					duration:1,
					y: 0,
					autoAlpha: 1,
					ease: Power4.easeOut
				});
				tlMobileNavigation.from('#mobile-navigation .menu li, #mobile-navigation .header-btn-wrapper, .mobile-navigation-footer .footer-email, .mobile-navigation-footer .footer-address, .mobile-navigation-footer .copyright,  .mobile-navigation-footer .footer-social', {
					duration:.6,
					y: 100,
					autoAlpha: 0,
					stagger: .1,
					ease: Power4.easeOut
				},'-=.6');
				
				
				
				//console.log(isNavActive);
			} else {
				this.hideMobileNav();
			}
	}, 
	
	animateNavigation: function() {
		var tlNavigation = gsap.timeline({
			delay: .3
			
		});
		tlNavigation.to('#main-logo',  {
			duration: .6,
			y: 0,
			autoAlpha: 1,
			ease: Power4.easeOut
		});
		tlNavigation.to('#main-navigation li, .navigation-buttons li',  {
			duration: .6,
			y: 0,
			autoAlpha: 1,
			stagger: .1,
			ease: Power4.easeOut
		},
		'-=.3');
	},
	
	showHeader: function() {
		$('#main-header').removeClass('hide-nav').addClass('scrolling-nav').removeClass('scrolling-nav');
	},
	
	autoHideHeader: function() {
		//console.log(windowWidth);
			myVars.currentTop = $(window).scrollTop();
		
			if( myVars.currentTop > 150){
				if (myVars.previousTop - myVars.currentTop > myVars.scrollDelta) {
		 			//if scrolling up...
		 			$('#main-header').removeClass('defaul-nav').removeClass('hide-nav').addClass('scrolling-nav');
				} else if (myVars.currentTop - myVars.previousTop > myVars.scrollDelta && myVars.currentTop > myVars.scrollOffset) {
		 			//if scrolling down...
		 			
		 			if($('#main-header').hasClass('scrolling-nav')){
		 				$('#main-header').removeClass('defaul-nav').removeClass('scrolling-nav').addClass('hide-nav');
		 			} else {
		 				$('#main-header').addClass('hide-default-nav');
		 			}
				}
				
			} else if( myVars.currentTop <= 0){
				$('#main-header').removeClass('hide-default-nav').removeClass('scrolling-nav').addClass('defaul-nav');
			}
			
			myVars.previousTop = myVars.currentTop;
			myVars.scrolling = false;
			
		
	}

};

},{}],8:[function(require,module,exports){
module.exports = {
	subscribeToMailchimp: function () {
		$('#mc-embedded-subscribe-form').submit(function(e) {
			e.preventDefault(); // Prevents the default form submission action
			
			var postData = $(this).serialize(); // Serializes form data
	        var formURL = $(this).attr('action').replace('/post?', '/post-json?') + '&c=?'; // Changes the action URL to return JSON
			
			        $.ajax({
				type: 'GET',
				url: formURL,
				data: postData,
				cache: false,
				dataType: 'jsonp',
				// JSONP to avoid cross-origin issues
	            jsonp: 'c',
				// Callback parameter for JSONP
	            contentType: "application/json; charset=utf-8",
				error: function (error) { 
	                // Error handling
				},
					success: function (data) {
					if (data.result != "success") {
						 var erroMessage = data.msg;
						 erroMessage = erroMessage.substring(erroMessage.indexOf("-") + 1);
	                     $('#mce-error-response').html(erroMessage).fadeIn();
					} else {
						console.log(data.result)
						$('#mce-error-response').hide();
	                    $('#mce-success-response').fadeIn();
						setTimeout(function(){
							$('#mce-success-response').fadeOut();
							$('#mc-embedded-subscribe-form')[0].reset();
						}, 2000);
					}
				}
			});
		});
	}
}

},{}],9:[function(require,module,exports){
module.exports = {
	

	parseCubicBezier: function(easeString) {
		const [x1, y1, x2, y2] = easeString
		    .replace(/cubic-bezier|\(|\)/g, '')
		    .split(',')
		    .map(parseFloat);
			function cubicBezier(t) {
				const cx = 3.0 * x1;
				const bx = 3.0 * (x2 - x1) - cx;
				const ax = 1.0 - cx - bx;
				const cy = 3.0 * y1;
				const by = 3.0 * (y2 - y1) - cy;
				const ay = 1.0 - cy - by;
				function sampleCurveDerivativeX(t) {
					return (3.0 * ax * t + 2.0 * bx) * t + cx;
				}
				
				function sampleCurveX(t) {
					return ((ax * t + bx) * t + cx) * t;
				}
				
				function solveCurveX(x, epsilon) {
					let t0, t1, t2, x2, d2, i;
					for (t2 = x,
						i = 0; i < 8; i++) {
						x2 = sampleCurveX(t2) - x;
						if (Math.abs(x2) < epsilon) {
							return t2;
						}
						
						d2 = sampleCurveDerivativeX(t2);
						if (Math.abs(d2) < 1e-6) {
							break;
						}
						
						t2 = t2 - x2 / d2;
					}
					
					t0 = 0.0;
					t1 = 1.0;
					t2 = x;
					if (t2 < t0) {
						return t0;
					}
					
					if (t2 > t1) {
						return t1;
					}
					
					while (t0 < t1) {
						x2 = sampleCurveX(t2);
						if (Math.abs(x2 - x) < epsilon) {
							return t2;
						}
						
						if (x > x2) {
							t0 = t2;
						} else {
							t1 = t2;
						}
						
						t2 = (t1 - t0) * 0.5 + t0;
					}
					
					return t2; // Failure.
				}
				
				function solve(x, epsilon) {
					return sampleCurveY(solveCurveX(x, epsilon));
				}
				
				function sampleCurveY(t) {
					return ((ay * t + by) * t + cy) * t;
				}
				
				return solve(t, 1 / 200);
			}
			
			return cubicBezier;
		
		},

	initPageAnimations: function() {
		
		gsap.registerPlugin(ScrollTrigger,ScrollToPlugin, SplitText,DrawSVGPlugin, TextPlugin);

		document.fonts.ready.then(function () {
		
		
		
		
		var theStart = "top bottom";
			
			if( myVars.windowWidth > 640){
				theStart = "top bottom";
			}
			
			/* Animate Mark */
//			TweenMax.staggerFromTo("#spark line", .4, {drawSVG:"0% 0%"}, {drawSVG:"0% 100%"}, 0.15);
			gsap.set("#spark line", {drawSVG:"0% 0%"});
			gsap.to("#spark line", {drawSVG:"0% 100%",duration: .6, stagger: 0.15, delay: .3, ease: module.exports.parseCubicBezier('cubic-bezier(0.76, 0, 0.24, 1)') });

			
				/* Animate SVG Lines */
			
			gsap.utils.toArray(".draw-icon svg").forEach(draw => {
			  
			  var tlDraw = gsap.timeline({
			    scrollTrigger: {
			      trigger: draw,
				  start: "top bottom",
				  toggleActions: "play none none reverse",
			    }
			  });
			
			  tlDraw.from($('path, circle, rect',draw), {
			    duration:.6,
				drawSVG: 0,
				stagger: 0.05,
				delay: .5
			  });
			  
			});	
						
			/* Animate Headings */
			
		  	
			gsap.utils.toArray(".animation-header").forEach(header => {
			  
			  
//			var headerchildSplit = new SplitText(header, {
//				type: "chars,words,lines",
//				linesClass: "split-child"
//			});
//			var headerparentSplit = new SplitText(header, {
//				 type: "chars,words,lines",
//				linesClass: "split-parent"
//			});
//			  
//			  
//			  var tl = gsap.timeline({
//			    scrollTrigger: {
//			      trigger: header,
//				  start: "top bottom",
//				  toggleActions: "play none none reverse",
//			      markers: false
//			    }
//			  });
//			
//			  tl.from(headerchildSplit.chars, {
//				duration: .7,
//				yPercent: 100,
//				stagger: .02,
//				opacity:0,
//				ease: "power4",
//				delay: 0
//			});

 			var tl = gsap.timeline({
			    scrollTrigger: {
			      trigger: header,
				  start: "-320 bottom",
				  toggleActions: "play none none reverse",
			      markers: false
			    }
			  });
			
			  tl.to(header, {
			    duration: 1,
				y: 0,
			    autoAlpha: 1,
				ease: "power4",
			  });
			  
			});
			
			
							
			
			/* Animate Thumbnails */
			
			gsap.utils.toArray(".animation-thumbnails").forEach(reveal => {
			  
			  var tl = gsap.timeline({
			    scrollTrigger: {
			      trigger: reveal,
				  start: "top bottom",
				  toggleActions: "play none none reverse",
			      markers: false
			    }
			  });
			
			  tl.to(reveal, {
			    duration: 1,
				height: 0,
				ease: "power4"
			  });
			  
			});
		
		gsap.utils.toArray(".animation-hero_image").forEach(reveal => {
			  
			  var tl = gsap.timeline({
			    scrollTrigger: {
			      trigger: reveal,
				  start: "top bottom",
				  toggleActions: "play none none reverse",
			      markers: false
			    }
			  });
			
			  tl.to(reveal, {
			    duration: 1,
				height: 0,
				ease: "power4",
				delay: .3
			  });
			  
			});
			
			/* Animate UI Elements */
			
			gsap.utils.toArray(".animation-reveal").forEach(reveal => {
			  
			  var tl = gsap.timeline({
			    scrollTrigger: {
			      trigger: reveal,
				  start: "-320 bottom",
				  toggleActions: "play none none reverse",
			      markers: false
			    }
			  });
			
			  tl.to(reveal, {
			    duration: 1,
				y: 0,
			    autoAlpha: 1,
				ease: "power4",
			  });
			  
			});
			
		
						
			gsap.utils.toArray(".animation-stagger").forEach(stagger => {
			  
			  var tlStagger = gsap.timeline({
			    scrollTrigger: {
			      trigger: stagger,
				  start: "-320 bottom",
				  toggleActions: "play none none reverse",
			      markers: false
			    }
			  });
			
			  tlStagger.to($('.animated',stagger), {
			    duration: 1,
				y: 0,
			    autoAlpha: 1,
				ease: "power4",
				stagger: 0.1
			  });
			  
			});
			
			
		});
		
	}, 
	
	killAllScrollTrigger: function() {
		let Alltrigger = ScrollTrigger.getAll()
			for (let i = 0; i < Alltrigger.length; i++) {
			Alltrigger[i].kill(true)
		}
	},
	
	
	initParallax: function() {
		
		var $parallaxElements = $('.parallax');
	
	
		gsap.utils.toArray(".parallax").forEach(reveal => {
			  
			  let speed = reveal.getAttribute('data-parallax-speed');
			  
			  var tl = gsap.timeline({
			    scrollTrigger: {
			      trigger: reveal,
				  start: "top bottom", // When the top of the element hits the bottom of the viewport
	                end: "bottom top", // When the bottom of the element exits the top of the viewport
	                scrub: true // Smooth scrubbing, true to tie it directly to scroll position
			    }
			  });
			
			  tl.to(reveal, {
			    yPercent: -parseFloat(speed) * 60,
	            ease: "none",
			  });
			  
			});
	
	
	    // Initialize parallax for each element
	   	}
	
	
	

};
},{}],10:[function(require,module,exports){
module.exports = {
	
	initColorScheme: function () {
		
		
		if(myVars.themeSwitcher == 1){
			var mediaQuery = window.matchMedia('(prefers-color-scheme: dark)');
		
		    const colorSchemeChanged = (e) => {
		        if (e.matches) {
		            this.checkThemeMode('dark');
		        } else {
		            this.checkThemeMode('light');
		        }
		    }
			mediaQuery.removeListener(colorSchemeChanged);
		    mediaQuery.addListener(colorSchemeChanged);
		    colorSchemeChanged(mediaQuery);
		} else {
			this.setColorVars();
		}
	},
	
	checkThemeMode: function (colorScheme) {
		
		var activeColor = colorScheme == 'dark' ? myVars.darkTheme : (colorScheme == 'light' ? myVars.lightTheme : '');
		
			$('body').removeClass('bg-brand-purple-light bg-brand-violet-light bg-brand-teal-light bg-brand-mint-light').addClass('bg-brand-'+activeColor+'-light');
			
				if (activeColor == 'purple') {
					colorHighlight = '#C09FFF'; // Define your purple highlight color
					colorMedium = '#C09FFF'; // Define your purple highlight color
					colorLight = '#D6C5FF'; // Define your purple light color
					colorDark = '#1A1638'; // Define your purple dark color
				} 
				// Check if body has class bg-brand-teal
				else if (activeColor == 'teal') {
					colorHighlight = '#72D9D9'; // Define your teal highlight color
					colorMedium = '#72D9D9'; // Define your teal highlight color
					colorLight = '#B2EBEB'; // Define your teal light color
					colorDark = '#0E1E25'; // Define your teal dark color
				} 
				else if (activeColor == 'mint') {
					colorHighlight = '#9AF2B2'; // Define your teal highlight color
					colorMedium = '#9AF2B2'; // Define your teal highlight color
					colorLight = '#C0FFD1'; // Define your teal light color
					colorDark = '#0E2C20'; // Define your teal dark color
				} 
				else if (activeColor == 'violet') {
					colorHighlight = '#8885FF'; // Define your teal highlight color
					colorMedium = '#8885FF'; // Define your teal highlight color
					colorLight = '#ABA9FF'; // Define your teal light color
					colorDark = '#151431'; // Define your teal dark color
				}
				document.documentElement.style.setProperty('--color-highlight', colorHighlight);
				document.documentElement.style.setProperty('--color-light', colorLight);
				document.documentElement.style.setProperty('--color-medium', colorMedium);
				document.documentElement.style.setProperty('--color-dark', colorDark);
					
	},
	
	checkBgColor: function (container) {
		var topSection = $(".section:first", container );
		var mainHeader = $('#main-header');
		var announcement = $('#announcement');
		mainHeader.removeClass('nav-dark nav-light');
		announcement.removeClass('bg-light bg-dark');
		
		if(topSection.hasClass('bg-dark')){
			mainHeader.addClass('nav-light');
			announcement.addClass('bg-light');
		} else if(topSection.hasClass('bg-light') || topSection.hasClass('bg-transparent')){
			mainHeader.addClass('nav-dark');
			announcement.addClass('bg-dark');
		} else if(topSection.hasClass('bg-medium')){
			mainHeader.addClass('nav-dark');
			announcement.addClass('bg-dark');
		}
		
	},
	
	
	setColorVars: function (container) {
		var body = $('body');
		var colorHighlight;
		var colorLight;
		var colorMedium;
		var colorDark;
		
		// Check if body has class bg-brand-purple
		if (body.hasClass('bg-brand-purple-light')) {
			colorHighlight = '#C09FFF'; // Define your purple highlight color
			colorMedium = '#C09FFF'; // Define your purple highlight color
			colorLight = '#D6C5FF'; // Define your purple light color
			colorDark = '#1A1638'; // Define your purple dark color
		} 
		// Check if body has class bg-brand-teal
		else if (body.hasClass('bg-brand-teal-light')) {
			colorHighlight = '#72D9D9'; // Define your teal highlight color
			colorMedium = '#72D9D9'; // Define your teal highlight color
			colorLight = '#B2EBEB'; // Define your teal light color
			colorDark = '#0E1E25'; // Define your teal dark color
		} 
		else if (body.hasClass('bg-brand-mint-light')) {
			colorHighlight = '#9AF2B2'; // Define your teal highlight color
			colorMedium = '#9AF2B2'; // Define your teal highlight color
			colorLight = '#C0FFD1'; // Define your teal light color
			colorDark = '#0E2C20'; // Define your teal dark color
		} 
		else if (body.hasClass('bg-brand-violet-light')) {
			colorHighlight = '#8885FF'; // Define your teal highlight color
			colorMedium = '#8885FF'; // Define your teal highlight color
			colorLight = '#ABA9FF'; // Define your teal light color
			colorDark = '#151431'; // Define your teal dark color
		} 
				
		// Set Sass variables
		document.documentElement.style.setProperty('--color-highlight', colorHighlight);
		document.documentElement.style.setProperty('--color-light', colorLight);
		document.documentElement.style.setProperty('--color-medium', colorMedium);
		document.documentElement.style.setProperty('--color-dark', colorDark);
		
			
	}
};
	
},{}],11:[function(require,module,exports){
var vars = require('./vars.js');
var announcement = require('../../../partials/announcement/announcement.js');
var navigation = require('../../../partials/navigation/main/navigation.js');
var newsletter = require('../../../partials/newsletter/newsletter.js');
var animations = require('./animations.js');
var team = require('../../../partials/blocks/team/team.js');
var colors = require('./colors.js');
var news = require('../../../partials/blocks/news/news.js');
var faq = require('../../../partials/blocks/faq/faq.js');
var mailingList = require('../../../partials/blocks/mailing-list/mailing_list.js');
var hotspots = require('../../../partials/blocks/hotspots/hotspots.js');


 
jQuery(document).ready(function($) {
	
	gsap.registerPlugin(ScrollTrigger,ScrollToPlugin, SplitText,DrawSVGPlugin, TextPlugin);

	$(window).on('resize', function() {
		myVars.windowWidth = window.innerWidth;
		if( myVars.windowWidth > 536){
			myVars.navbarHeight = $('#main-header').outerHeight();
			navigation.hideMobileNav();
		} 		
	});
	
	$(window).on('scroll', function() {
		if (!myVars.scrolling) {
			myVars.scrolling = true;
			(!window.requestAnimationFrame)
				? setTimeout(navigation.autoHideHeader, 250)
				: requestAnimationFrame(navigation.autoHideHeader);
		}
	});


	 
/* Init */
 
	function init(container){
	  	initFancybox();
	  	colors.initColorScheme();
	  	announcement.hideAnnouncement();
	  	colors.checkBgColor(container);
	  	$(window).scrollTop(0);
	  	navigation.hideMobileNav();
		navigation.showHeader();
		team.initTeamCarousel();
		faq.initFAQ();
		mailingList.initFormLabel();
		mailingList.submitForm(container);
		animateAnchorLinks();
	  	animations.initPageAnimations();
	  	//hotspots.initHotspots();
	  	initTooltip();
	} 
 
	function initTooltip(){
	
		$('.hotspot').circleTooltip({
	        backgroundColor: '#F5F5F9',
	        textColor: '#1A1638',
	        fontSize: '16px' ,
			
			
	    });
	}
	
	
	function initFancybox(){
		Fancybox.bind("[data-fancybox]", {
			Thumbs: {
				type: "classic",
			},
			 mobile : {
			 	arrows: false
			 }
		});
	}
		
	$('.mobile-menu-icon').on('click', function(e) {
		e.preventDefault();
		navigation.showMobileNav();
	});

	function animateAnchorLinks(){
	 $('a[href^="#"]:not(.link-fancybox)').click(function(e) {
	        // Prevent the default anchor behavior
	        e.preventDefault();
	        var targetId = $(this).attr('href');
	        // If the targetId is not just '#'
	        if (targetId.length > 1) {
	            // Use animate() function to smoothly scroll to the target section
	            $('html, body').animate({
	                scrollTop: $(targetId).offset().top
	            }, 1000); // Adjust the duration (1000ms) as per your need
	        }
	    });
	}

	
	
	function addCurrentMenuClass(){
	
		var url = $(location).attr('href').replace(/\/+$/,''),
		parts = url.split("/"),
		last_part_url = parts[parts.length-1];
		
		
		$("#main-navigation .menu li a, #mobile-navigation .menu li a").removeClass('current');
		$("#main-navigation .menu li a, #mobile-navigation .menu li a").each(function( index ) {
		  
		  var link_url = $(this).attr('href').replace(/\/+$/,'').split("/");
		  var link_url_last_part = link_url[link_url.length-1];
		  if(last_part_url == link_url_last_part) {
			$(this).addClass('current');
		  }
		  
		});
	
	}
	
	barba.init({
	cacheIgnore: false,
	timeout: 6000,
	sync: true,
	views: [
				{
					namespace: 'home',
					async beforeEnter(data) {
					}
				},
				
			],
	transitions: [
			{
				async beforeOnce(data) {
				},
				async leave(data) {
					var done = this.async();
					gsap.to(data.current.container,
					{
						duration: .4,
						y:  -300,
						opacity: 0,
						ease: Power4.easeIn,
						force3D:true,
						onComplete: done
					});
				},
				async once(data) {
					init(data.next.container);
					navigation.animateNavigation();
					gsap.to(data.next.container,
					{
						duration: 1.6,
						autoAlpha: 1,
						y: 0,
						force3D:true,
						ease: Power4.easeOut,
						
					});	
					var sectionHash = window.location.hash;
					if(sectionHash) {
						console.log(sectionHash);
						$('html, body').animate({
			                scrollTop: $(sectionHash).offset().top
			            }, 1000);
					}
					
					
				},
				
				async afterEnter(data) {
					reinitForm();
				},
				async enter(data) {
					gsap.to(data.next.container,
					{
						duration: 1.6,
						opacity: 1,
						y: 0,
						force3D:true,
						ease: Power4.easeOut
					});
				},
				async beforeEnter(data) {
				  	init(data.next.container);
				},
			}
			
		]
		
});




barba.hooks.afterEnter((data) => {
	
	var vids = document.querySelectorAll("video");
	if(vids){
		vids.forEach(vid => {
			var playPromise = vid.play();
			if (playPromise !== undefined) {
				playPromise.then(_ => {}).catch (error => {});
			};
		});
	}
	addCurrentMenuClass();
});

barba.hooks.afterLeave((data) => {
  // Set <body> classes for "next" page
	var nextHtml = data.next.html;
	var response = nextHtml.replace(/(<\/?)body( .+?)?>/gi, '$1notbody$2>', nextHtml);
	var bodyClasses = $(response).filter('notbody').attr('class');
	$("body").attr("class", bodyClasses);
	
	
});

function reinitForm(){
	if (window.wpcf7) {
		
		document.querySelectorAll('.wpcf7-form').forEach(form => {
			wpcf7.init(form);
		});
		
		$('.wpcf7-form .wpcf7-form-control').on('focus blur', function(e) {
			
			var $label = $(this).parent().parent().find('.form-label');

		    if (e.type === 'focus' || $(this).val()) {
		        $label.addClass('active');
		    } else {
		        $label.removeClass('active');
		    }
	    });
		
	}
}


});


},{"../../../partials/announcement/announcement.js":1,"../../../partials/blocks/faq/faq.js":2,"../../../partials/blocks/hotspots/hotspots.js":3,"../../../partials/blocks/mailing-list/mailing_list.js":4,"../../../partials/blocks/news/news.js":5,"../../../partials/blocks/team/team.js":6,"../../../partials/navigation/main/navigation.js":7,"../../../partials/newsletter/newsletter.js":8,"./animations.js":9,"./colors.js":10,"./vars.js":12}],12:[function(require,module,exports){

	window.myVars = {
		themeSwitcher : $('body').data('theme_switcher'),
		lightTheme : $('body').data('light_theme'),
		darkTheme : $('body').data('dark_theme'),
		scrolling : false,
		previousTop : 0,
		currentTop : 0,
		scrollDelta : 5,
		scrollOffset : 100,
		navbarHeight : $('#main-header').outerHeight(),
		isNavActive : false,
		windowWidth : window.innerWidth,
		currentTop:'',
		fontLoaded : false,
		isMobile : false,
	};	
		
		
},{}]},{},[11]);
